export const sum = (arr: number[]): number => {
  return arr.reduce((accumulator, current) => {
    return accumulator + current;
  }, 0);
};
